package ui.app.assign.detail.wheel

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.ImageBitmap
import apps.App
import org.ssoft.common.app.AppItemQrCode
import org.ssoft.common.tools.nowDateTime
import ui.app.assign.detail.wheel.editor.AppEditorWheelScope
import kotlin.time.Clock


@Composable
fun AppEditorWheelScope.AppWheelRendererReward(
    nnvl: AppEditorWheelScope.Wrapper,
    item: AppEditorWheelScope.ItemsWrapper.Item,
    boxModifier: Modifier
) {
    val isLand = remember {
        nnvl.orientation.state == App.Wheel.Theme.ORIENTATION_LAND
    }
    Reward(
        app = nnvl.appRef,
        item = item,
        modifier = Modifier.let {
            if (isLand) {
                boxModifier.aspectRatio(16F / 9F, false)
            } else {
                boxModifier.aspectRatio(9F / 16F, false)
            }
        })
}

@Composable
fun AppEditorWheelScope.Reward(
    item: AppEditorWheelScope.ItemsWrapper.Item,
    modifier: Modifier,
    app: App.Wheel,
) {
    val image = remember {
        mutableStateOf<ImageBitmap?>(null)
    }
    val code = remember {
        AppItemQrCode.generateQr(
            appId = app.appId,
            appType = app.type,
            itemGroupId = item.data.idGroup,
            itemId = item.data.idItem,
            dt = Clock.nowDateTime()
        )
    }
    LaunchedEffect(
        item.data.idItem,
        item.name.state,
        item.reward.state,
        item.iconSvg.state,
        item.iconImage.state,
        item.colorBg.state,
        item.colorFg.state
    ) {
        image.value = vm.resultGenerator.generate(
            fontResolver = textResolver,
            item = item.data,
            code = code,
            isLand = vm.state.entry?.appRef?.content?.theme?.isLand == true
        )
    }
    image.value?.also {
        Image(it, null, modifier = modifier)
    }
}